import styled from 'styled-components';
import { grid } from '@finect/tabular-utils/grid';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

export const OtherArticles = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  padding-top: 30px;
  margin: 0 auto 30px;

  ${maxMediaQueries.miniDesktop`
    margin-top: -12px;
  `};

  ${maxMediaQueries.phablet`
    display: block;
  `};

  h5 {
    margin-bottom: 6px;

    &:not(:first-child) {
      margin-top: 30px;
    }
  }

  > div {
    width: ${grid(4)}px;
    max-width: 100%;

    ${maxMediaQueries.phablet`
      margin-left: auto;
      margin-right: auto;
    `};

    &:first-child {
      padding-right: 48px;

      ${maxMediaQueries.phablet`
        margin-bottom: 48px;
        padding-right: 0;
      `};
    }

    &:last-child {
      padding-left: 48px;
      border-left: 1px solid ${({ theme }) => theme.borderColorL};

      ${maxMediaQueries.phablet`
        padding-left: 0;
        border-left: none;
      `};
    }
  }
`;
